import React, { Fragment, useEffect, useState } from 'react'
import { Box, Chip, Grid, IconButton, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tabs, Tooltip, tooltipClasses, Typography } from '@mui/material'
import { TabContext, TabPanel } from '@mui/lab'
import { AddBusinessTwoTone, BuildCircleTwoTone, ColorLensTwoTone, DeleteTwoTone, DirectionsCarFilledTwoTone, EditTwoTone, KeyboardArrowLeft, KeyboardArrowRight, PersonOutlineTwoTone, TwoWheelerTwoTone, VisibilityTwoTone } from '@mui/icons-material'
import { BsPlusLg } from 'react-icons/bs'
import VehiclesServices from 'app/apis/Vehicles/VehiclesServices'
import Layout from 'app/layout/Layout'
import AddVehicleTypeDialog from 'app/components/Dialog/VehicleDialogs/VehicleTypeDialog'
import colors from 'app/styles/colors'
import { ErrorToaster, SuccessToaster } from 'app/components/Toaster/Toaster'
import AddVehicleColorDialog from 'app/components/Dialog/VehicleDialogs/VehicleColorDialog'
import AddVehicleMakeDialog from 'app/components/Dialog/VehicleDialogs/VehicleMakeDialog'
import AddVehicleModelDialog from 'app/components/Dialog/VehicleDialogs/VehicleModelDialog'
import BreadCrumbs from 'app/components/Breadcrumbs/Breadcrumbs'
import { Loading } from 'app/assets/Images'
import { useTheme } from '@emotion/react'
import { styled } from '@mui/styles'
import SimpleDialog from 'app/components/Dialog/ValidationDialog'
import { useNavigate } from 'react-router-dom'
import CompanyFilter from 'app/components/Filters/CompanyFilter'
import { StatusChip } from 'app/components/UI/Chip'
import { ImageAvatar } from 'app/components/Avatar/ImageAvatar'
import VehicleDocument from 'app/components/Dialog/VehicleDocument'

// Table Pagination ActionsComponent
function TablePaginationActions(props) {

  const theme = useTheme

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };



  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
    </Box>
  );
}

function Vehicles() {

  const navigate = useNavigate()

  const tableHead = ['#ID', 'Vehicle Info', 'Vehicle Driver', 'Vehicle Documents', 'Status']

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // *For Loader
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);

  // *For Dialog Box
  const [deleteDialog, setDeleteDialog] = useState(false);
  // *For Documents Dialog Box
  const [vehicleDocDialog, setVehicleDocDialog] = useState(false);
  const [vehicleDocs, setVehicleDocs] = useState([])

  // *For Vehicles
  const [vehicles, setVehicles] = useState([]);
  const [vehicleId, setVehicleId] = useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // *For Get Vehicles
  const getVehicles = async () => {
    setLoader(true)
    try {
      const { status, responseCode, data } = await VehiclesServices.getVehicles()
      if (status === true && responseCode === 200) {
        setVehicles(data)
      }
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  // *For Delete Vehicle
  const deleteVehicle = async () => {
    setLoading(true)
    try {
      const { status, responseCode, message } = await VehiclesServices.deleteCompany(vehicleId)
      if (status === true && responseCode === 200) {
        SuccessToaster(message)
        getVehicles()
        setDeleteDialog(false)
      }
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getVehicles()
  }, [])

  return (
    <Fragment>

      {/* ========== Delete Dialog ========== */}
      <SimpleDialog open={deleteDialog} onClose={() => setDeleteDialog(false)} title={'Are you sure to remove this?'} action={deleteVehicle} loading={loading} />
      <VehicleDocument
        vehicleDocs={vehicleDocs}
        open={vehicleDocDialog}
        handleClose={() => { setVehicleDocDialog(!vehicleDocDialog); setVehicleDocs("") }} />
      <Box sx={{
        backgroundColor: colors.lightGray, p: 3, borderRadius: "12px", width: "calc(100vw - 370px)"
      }}>
        <Grid container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            bgcolor: colors.white, p: 2, borderRadius: "12px",
          }}>
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">Vehicles List</Typography>
          </Grid>
          <Grid item xs={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <BreadCrumbs currentPage={['Vehicles']} />
          </Grid>
        </Grid>
        {loader ? (
          <Box sx={{ width: 1, textAlign: "center", pt: 5 }}>
            <Loading />
          </Box>
        ) : (
          <Fragment>

            {/* ========== Filter ========== */}
            {/* <CompanyFilter /> */}

            <TableContainer component={Paper}
              sx={{
                '&::-webkit-scrollbar': {
                  bgcolor: colors.white,
                  height: "8px",
                  borderRadius: "10px",
                  cursor: "pointer"
                },
                '&::-webkit-scrollbar-thumb': {
                  bgcolor: colors.primary,
                  borderRadius: "10px",
                  cursor: "pointer"
                },
                "&.MuiPaper-root": {
                  borderRadius: "12px",
                  mt: 2,
                  boxShadow: 0,
                }
              }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead >
                  <TableRow sx={{ bgcolor: colors.lightGray }}>
                    {tableHead.map((item, index) => (
                      <TableCell key={index} sx={{ fontWeight: "bold" }} >{item}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0 ? vehicles?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : vehicles).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {row.id}
                      </TableCell>
                      <TableCell >
                        <Typography variant='body2'>
                          <b>Model Name: </b>
                          {row?.model?.name ?? '--'}
                        </Typography>
                        <Typography variant='body2'>
                          <b>Engine Class: </b>
                          {row?.model?.engine_class ?? '--'}
                        </Typography>
                        <Typography variant='body2'>
                          <b>Engine CC: </b>
                          {row?.model?.engine_cc ?? '--'}
                        </Typography>
                        <Typography variant='body2'>
                          <b>Manufacturer: </b>
                          {row?.model?.make?.gender ?? '--'}
                        </Typography>
                        <Typography variant='body2'>
                          <b>Type: </b>
                          {row?.model?.make?.type?.type ?? '--'}
                        </Typography>
                        <Typography variant='body2'>
                          <b>No of Seats: </b>
                          {row?.model?.make?.type?.max_seats ?? '--'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex' }}>
                          <Box sx={{ mr: 1 }}>
                            <ImageAvatar image={row?.driver?.picture} />
                          </Box>
                          <Box>
                            <Typography variant='body2'>
                              <b>Name: </b>
                              {row?.driver?.name ?? '--'}
                            </Typography>
                            <Typography variant='body2' noWrap>
                              <b>Email: </b>
                              {row?.driver?.email ?? '--'}
                            </Typography>
                            <Typography variant='body2'>
                              <b>Phone: </b>
                              {row?.driver?.phone ?? '--'}
                            </Typography>
                            <Typography variant='body2'>
                              <b>Gender: </b>
                              {row?.driver?.gender ?? '--'}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>
                        <Chip
                          onClick={() => { setVehicleDocDialog(!vehicleDocDialog); setVehicleDocs(row.documents) }}
                          label={`View`}
                          sx={{
                            bgcolor: colors.bondiBlueLight + 26,
                            color: colors.bondiBlueLight,
                            height: 26,
                            textTransform: 'capitalize',
                            cursor: 'pointer'
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <StatusChip status={row?.is_active} />
                      </TableCell>
                    </TableRow>
                  ))}

                </TableBody>
              </Table>
            </TableContainer>
            <Table sx={{ marginTop: "12px" }}>
              <TablePagination
                sx={{ borderBottom: "none", bgcolor: colors.white, borderRadius: "12px" }}
                rowsPerPageOptions={[10, 25, 50]}
                colSpan={15}
                count={vehicles.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Table>

          </Fragment>
        )}

      </Box>
    </Fragment>
  )
}

export default Vehicles